import React from "react";

import "../style/navbar.css";

function LogoComp() {
  return <div className="logo-comp">EA</div>;
}

export default LogoComp;
